export const styles = {
    pathOpacity: 0.7,
};
